import { render, staticRenderFns } from "./PaymentsTab.vue?vue&type=template&id=47726c0e&scoped=true"
import script from "./PaymentsTab.vue?vue&type=script&lang=js"
export * from "./PaymentsTab.vue?vue&type=script&lang=js"
import style0 from "./PaymentsTab.vue?vue&type=style&index=0&id=47726c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47726c0e",
  null
  
)

export default component.exports